<template>
    <li class="section-menu-item" :class="{ active: active == index, open: submenu, 'mobile-only': mobileOnly }">
        <div v-if="hasPacket || noPacket">
            <router-link v-if="!lv2 || item.parentClickable"
                         :to="{ name: item.path }"
                         @click="toggleSubmenu(item.parentClickable)"
                         :class="{ active: active == index }">{{ item.name }}</router-link>
            <span v-if="lv2 && !item.parentClickable"
                  @click="toggleSubmenu(true)"
                  :class="{ active: active == index, open: submenu }">{{ item.name }}</span>
            <ul v-if="lv2 && submenu">
                <li class="section-menu-item section-menu-item--lv2" v-for="(item, index) in lv2" :key="index">
                    <router-link v-if="!item.external" :to="{ name: item.path }">{{ item.name }}</router-link>
                    <a v-if="item.external" target="_blank" :href="item.path">{{item.name}}</a>
                </li>
            </ul>
        </div>
        <div class="item-disabled"
             v-if="!hasPacket && !noPacket">
            <span>{{ item.name }}</span>
        </div>
    </li>
</template>

<script>
    export default {
        props: ['item', 'index', 'lv2', 'active', 'noPacket', 'mobileOnly', 'noPacketPath'],
        data () {
            return {
                submenu: false
            }
        },
        computed: {
            hasPacket () {
                return this.$store.getters.user.position != 0
            },

            menu () {
                return JSON.parse(JSON.stringify(this.$parent.menu))
            }
        },
        methods: {
            toggleSubmenu (toggleAvailable) {
                if(toggleAvailable) {
                    this.submenu = !this.submenu
                }
            }
        },
        mounted () {
            if (this.active === this.index) {
                this.submenu = true
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../../../assets/scss/_colors.scss";

    .section-menu-item{
        position: relative;
        margin-bottom: 6px;
        padding-left: 40px;

        a,
        span{
            display: block;
            font-size: 16px;
            text-transform: uppercase;
            font-weight: bold;
            line-height: 30px;
            color: $base2;
            cursor: pointer;
            transition: 200ms all linear;

            &.open{
                color: $base1;
            }

            &.active+ul .router-link-active,
            &.active{
                color: $base1;

                &:before{
                    position: absolute;
                    top: 7px;
                    left: 0;
                    width: 0;
                    height: 0;
                    content: '';
                    border-style: solid;
                    border-width: 7px 0 7px 13px;
                    border-color: transparent transparent transparent $base1;
                }
            }

            &:hover,
            &:focus{
                color: $base1;
                text-decoration: none;
            }
        }

        ul{
            li{
                padding-left: 20px;
            }
        }

        .item-disabled{
            span{
                color: #d3d3d3;
                cursor: not-allowed;

                &:hover,
                &:focus{
                    color: #848484;
                }
            }
        }
    }

    @media (max-width: 991px) {
        .section-menu-item{
            margin: 0;
            padding: 11px 0;
            background: #ececec;

            &:not(:last-child){
                 border-bottom: 1px solid #dadada;
            }

             &.open{
                padding-bottom: 0;

                a{
                    padding: 0 11px 11px;
                }

                .section-menu-item--lv2{
                    a{
                        padding: 0 11px;
                    }
                }
            }

            span,
            a{
                padding: 0 11px;

                &:before{
                     display: none !important;
                 }
            }

            span{
                &:after{
                     float: right;
                     display: inline-block;
                     vertical-align: middle;
                     margin-top: 11px;
                     width: 0;
                     height: 0;
                     border-style: solid;
                     content: "";
                     border-width: 7px 6.5px 0 6.5px;
                     border-color: $base1 transparent transparent transparent;
                }

                 &.open{
                    &:after{
                         border-width: 0 6.5px 7px 6.5px;
                         border-color: transparent transparent $base1 transparent;
                    }
                }
            }
    
            .item-disabled{
                span{
                    &:after{
                         display: none;
                     }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/menu/item/SectionMenuItem.vue